import { GetStaticProps } from "next"
import { BlogPage } from "../../modules/blog/BlogPage"
import { Photo } from "../../components/media/Photo"
import format from "date-fns/format"
import { pl } from "date-fns/locale"
import { MojeUrodzinyHead } from "../../components/head/MojeUrodzinyHead"

export default function BlogPageId({ post }) {
  return (
    <BlogPage>
      {post && (
        <MojeUrodzinyHead
          title={post.title + " blog MojeUrodziny.pl"}
          description="Najlepsze urodzinowe lokalizacje i usługi w swojej okolicy - Zorganizuj przyjęcie z MojeUrodziny.pl"
          image={
            post.imageUrl
              ? post.imageUrl
              : post.media
              ? post.media[0].url
              : undefined
          }
        />
      )}
      <div className="img">
        <Photo
          media={
            post.imageUrl
              ? { url: post.imageUrl }
              : post.media
              ? post.media[0]
              : undefined
          }
          radius={false}
        />
      </div>

      <div className="blogContent">
        {post.publishedAt && (
          <div className="date">
            {format(new Date(post.publishedAt), "yyyy | d LLLL", {
              locale: pl,
            })}
          </div>
        )}
        <div className="blogTitle">{post.title}</div>
        {post.videoUrl && (
          <div className="text-center flex flex-row justify-center my-2">
            <iframe width="420" height="315" src={post.videoUrl}></iframe>
          </div>
        )}
        <div dangerouslySetInnerHTML={{ __html: post.content }} />
      </div>
    </BlogPage>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const res = await fetch(
    process.env.NEXT_PUBLIC_API_URL + "/v1/public/articles/" + context.params.id
  )
  const post = await res.json()
  return {
    props: {
      post,
    },
    revalidate: 300,
  }
}

export async function getStaticPaths() {
  const paths = []
  return { paths, fallback: "blocking" }
}
